import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session.js';
import projectListingReducer from './projectListingReducer.mjs';
import { configureStore } from '@reduxjs/toolkit'

class ConfigureStore {
  constructor(name, id) {
    const persistConfig = {
      key: id,
      storage: storage.default,
    };

    const persistedReducer = persistReducer(
      persistConfig,
      projectListingReducer
    );

    // getDefaultMiddleware adds thunk and devtools middleware by default
    this.store = configureStore({
      reducer: persistedReducer,
      middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,        
      }),
      devTools: window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? { name: name} : false
    })

    this.persistor = persistStore(this.store);
  }
}

export default ConfigureStore;
